import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAuth } from '../../contexts/AuthContext';
import { UnsavedChangesDialog } from '../ui/UnsavedChangesDialog';
import { SessionWarningModal } from '../ui/SessionWarningModal';
import { useSessionWarning } from '../../hooks/useSessionWarning';

export function MainLayout() {
  const { activeSite, isAuthenticated, logout } = useAuth();
  const sessionWarning = useSessionWarning(isAuthenticated, logout);
  
  return (
    <div className="flex h-screen bg-slate-50">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main content area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header />
        
        {/* Page content */}
        <main className="flex-1 overflow-y-auto p-6">
          {/* Key fuerza re-mount de todos los componentes cuando cambia la sede */}
          <div key={activeSite?.id || 'no-site'}>
            <Outlet />
          </div>
        </main>
      </div>

      {/* Modal de confirmación para cambios sin guardar */}
      <UnsavedChangesDialog />

      {/* Modal de aviso de expiración de sesión */}
      <SessionWarningModal
        isVisible={sessionWarning.isVisible}
        secondsLeft={sessionWarning.secondsLeft}
        onContinue={sessionWarning.onContinue}
        onLogout={sessionWarning.onLogout}
      />
    </div>
  );
}

export default MainLayout;
